import { withModuleContext } from "@edreamsodigeo/frontend-core";
import { PrismaProvider } from "@edreamsodigeo/prisma-design-system";
export const MODULE_NAMESPACE = "manage_my_booking";
export const withPrismaProvider = withModuleContext({
  namespace: MODULE_NAMESPACE,
  PrismaProvider
});